// Polyfills for browser compatibility
// ethers.js and WalletConnect are no longer used; minimal polyfills needed for Vite SSR
if (typeof window !== 'undefined') {
  (window as any).global = window;
}